import React from 'react';
import { Tag } from 'antd';
import { CargoContractSides } from '@shared/utils/constants';

type Props = {
	contractSide: CargoContractSides;
	chartererName?: string | null;
};

const sideConfig = {
	[CargoContractSides.VC_OUT]: {
		label: 'VC-OUT',
		color: 'blue',
	},
	[CargoContractSides.VC_IN]: {
		label: 'VC-IN',
		color: 'purple',
	},
} as const;

const CargoContractSideTag = ({
	contractSide,
	chartererName,
}: Props) => {
	const config = sideConfig[contractSide];

	if (!config) {
		return <>{chartererName}</>;
	}

	const { label, color } = config;

	return (
		<>
			<Tag
				color={color}
				bordered={false}
				style={{
					textAlign: 'center',
					width: 70
				}}
			>
				{label}
			</Tag>
			{chartererName}
		</>
	);
};

export default CargoContractSideTag;
